import React, {
  useRef, useState,
  // useEffect 
} from 'react';

import Modal from 'react-bootstrap/Modal';
// import moment from 'moment';
import axios from 'axios';
import {
  validaSoloNumero, formatMoneda, validaMonto, formatoMonto,
  // validaNumeroTelefono, validaEmail
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import CatalogoTipoReten from '../../catalogos/catalogoTipoReten';
import CatalogoProveedor from '../../catalogos/catalogoProveedor';
import CatalogoCuentaContable from '../../catalogos/catalogoCuentaContable';

import { Input, Radio, SearchInput, Select } from '../../ui/inputs/Input';
import { DangerButton, SuccessButton } from '../../ui/buttons/Button';

export const ModalRetenciones = (props) => {
  let token = localStorage.getItem('jwtToken');
  let op = require('../../../src/modulos/datos');
  // let anio = JSON.parse(localStorage.getItem('anioactu'))
  // let idorganizacion = JSON.parse(localStorage.getItem('idorganizacion'));
  let idefiscal = JSON.parse(localStorage.getItem('idefiscal'))
  // const fechaTope = moment.utc(JSON.parse(localStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());
  // const deshabilitado = false;

  /*  variables de referencias */

  const chkPorcen = useRef();
  const chkMilPorcen = useRef();
  const chkUniTri = useRef();
  const chkMontFij = useRef();
  const chkOtroPor = useRef();
  const txtOtroPorcen = useRef();
  // const txtIdAgente = useRef();
  const txtIdProve = useRef();
  const txtIdCuenta = useRef();
  const txtCuentaCont = useRef();
  const txtIdCuenta2 = useRef();
  const txtCuentaCont2 = useRef();
  const txtId = useRef();
  const cmbTipo = useRef();
  const txtDescripcion = useRef();
  // const chkSi = useRef();
  // const chkNo = useRef();
  // const chkDepositos = useRef();
  // const txtNombre = useRef();
  // const txtNCuenta = useRef();
  // const txtSucursal = useRef();
  // const txtPersona = useRef();
  // const txtTelefono = useRef();
  // const txtPrepuesto = useRef();
  // const txtDireccion = useRef();
  // const txtSaldoCon = useRef();
  // const txtSaldoLib = useRef();
  // const txtConcepto = useRef();
  // const txtPorcenDeb = useRef();
  // const txtEmision = useRef();
  const txtDeducible = useRef();

  /*  variables de estados */
  const [catalogoProve, setCatalogoProve] = useState(false);
  const [cata, setCata] = useState(0)

  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  // const [bancos, setBancos] = useState()
  const [operacion, setOperacion] = useState(0);
  const [visibleISLR, setVisibleISLR] = useState('hidden')
  const [visibleOtro, setVisibleOtro] = useState(false)
  const [catalogoCuentaRe, setCatalogoCuentaRe] = useState(false)
  const [tercero, setTercero] = useState({
    idagente: '',
    nombre: ''
  })
  // const [idBanco, setIdBanco] = useState()
  const [catalogoTipoReten, setCatalogoTipoReten] = useState(false);
  // const [habilitado, setHabilitado] = useState(true);

  const [values, setValues] = useState({
    idtiporetencion: '',
    descripcion: '',
    unidad: '',
    idcuentacontable: '',
    tipo: '',
    deducible: '',
    otro: '',
    idagente: '',
  });
  // const styleInput = {
  //   backgroundColor: '#ffff',
  //   color: '#444242'
  // }

  // const styleInputDirec = {
  //   backgroundColor: '#ffff',
  //   color: '#444242',
  //   height: 50,

  // }
  const seleccionarProveedor = (id) => {
    setCatalogoTipoReten(false)
    let campos = '*';
    let nomtab = 'proveedor';
    let nomid = 'idproveedor';

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (response.data !== '') {
          txtIdProve.current.value = response.data.idproveedor;
          setTercero({
            nombre: response.data.rif + ' / ' + response.data.razonsocial
          })
        } else {
          txtIdProve.current.value = ''
          setTercero({

            nombre: ''
          })
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe este proveedor', icono: 'informacion' });
        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };
  function maskIt(pattern, value) {
    let position = 0;
    let currentChar = 0;
    let masked = "";
    while (position < pattern.length && currentChar < value.length) {
      if (pattern[position] === "0") {
        masked += value[currentChar];
        currentChar++;
      } else {
        masked += pattern[position];
      }
      position++;
    }
    return masked;
  }

  const onChange = (event) => {
    if (Number(event.target.value) === 4) {
      setVisibleOtro(true)
    } else {
      setVisibleOtro(false)
    }

    if (event.target.name === 'direccion' ||
      event.target.name === 'sucursal' ||
      event.target.name === 'contacto' ||
      event.target.name === 'concepto') {
      event.target.value = event.target.value.toUpperCase();
      setValues({ ...values, [event.target.name]: event.target.value.toUpperCase() });
    } else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
      event.target.value = '0,00'
    }
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      event.target.value = (formatoMonto(event.target.value));
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === '0' && char2 !== ',') {
        event.target.value = event.target.value.substring(1, event.target.value.legth);
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const procesarRegistro = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/administracion/actualizartipRetencion`;

    let body;

    body = {
      operacion: operacion,
      nid: values.idtiporetencion === '' ? 0 : values.idtiporetencion,
      descr: values.descripcion.toUpperCase().trim(),
      ip: parseInt(values.unidad),
      idprove: txtIdProve.current.value,
      plan: parseInt(values.tipo),
      dedu: txtDeducible.current ? txtDeducible.current.value === '' ? 0.00 : parseFloat(txtDeducible.current.value.replace(/\./g, '').replace(',', '.')) : 0,
      idcta: txtIdCuenta.current.value !== '' ? txtIdCuenta.current.value : 0,
      idctater: txtIdCuenta2.current.value !== '' ? txtIdCuenta2.current.value : 0,
      efis: idefiscal,
      otr: txtOtroPorcen.current ? txtOtroPorcen.current.value === '' ? 0.00 : parseFloat(txtOtroPorcen.current.value.replace(/\./g, '').replace(',', '.')) : 0
    }

    axios.post(endpoint, body, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (operacion === 1) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
        } else if (operacion === 2) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
        } else if (operacion === 3) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
        }
        blanquear()
        setActivate(false);
      }
    }).catch(function (error) {
      let mensaje = '';
      if (error.response === undefined) {
        mensaje = 'Error de Conexion'
      } else {
        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
          mensaje = 'Ya existe un Registro'
        }
        else {
          mensaje = error.response.data.message
        }
      }
      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
      setActivate(false);
    })
  };
  const mostrarCuenta = (op) => (e) => {
    e.preventDefault()
    setCata(op)
    setCatalogoCuentaRe(true)
  }

  const validarCuentaContable = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value !== '') {
        seleccionarCuentaRetencion(event.target.value);
      } else {
        txtIdCuenta.current.value = '';
      }
    }
  };
  const validarBene = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value !== '') {
        seleccionarProveedor(event.target.value);
      } else {
        setTercero({
          idagente: '',
          nombre: ''
        })
      }
    }
  };

  const blanquear = () => {
    cmbTipo.current.value = '';
    txtDescripcion.current.value = '';
    chkPorcen.current.checked = false;
    chkMilPorcen.current.checked = false;
    chkUniTri.current.checked = false;
    chkMontFij.current.checked = false;
    if (chkOtroPor.current.checked) {
      txtOtroPorcen.current ? (txtOtroPorcen.current.value = '') : '';

    }
    chkOtroPor.current.checked = false;
    setValues({
      idtiporetencion: '',
      descripcion: '',
      unidad: '',
      idcuentacontable: '',
      tipo: '',
      deducible: '',
      otro: '',
      idagente: '',
    })
    setTercero({
      idagente: '',
      nombre: ''
    })

  }

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    procesarRegistro();
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();

  }
  const onChangeValidar = () => {
    let sigue = true;
    if (visibleISLR === 'visible' && txtDeducible.current.value === '') {

      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar el Deducible.', icono: 'informacion' });
      sigue = false;
      txtDeducible.current.focus();

    } else if (txtDescripcion.current.value === '') {

      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar la Descripción.', icono: 'informacion' });
      sigue = false;
      txtDescripcion.current.focus();

    } else if (values.unidad === '') {

      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar una Unidad de Retención .', icono: 'informacion' });
      sigue = false;
      chkPorcen.current.focus();

    } else if (parseInt(values.unidad) === 4 && txtOtroPorcen.current.value === '') {

      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar un Porcentaje.', icono: 'informacion' });
      sigue = false;
      txtOtroPorcen.current.focus();

    } else if (cmbTipo.current.value === '') {

      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar el tipo.', icono: 'informacion' });
      sigue = false;
      cmbTipo.current.focus();

    } else if (txtIdProve.current.value === '') {

      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar el proveedor.', icono: 'informacion' });
      sigue = false;
      txtIdProve.current.focus();

    }
    if (sigue) {

      let msg = '';
      if (operacion === 1) {
        msg = 'Esta Seguro de Registrar estos Datos.';
      } else if (operacion === 2) {
        msg = 'Esta Seguro de Modificar estos Datos.';
      } else if (operacion === 3) {
        msg = 'Esta Seguro de Eliminar estos Datos.';
      }

      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
    }
  }

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const seleccionarCuentaRetencion = (id) => {

    setCatalogoCuentaRe(false)
    let campos = '*';
    let nomtab = 'cuentacontable';
    let nomid = 'idcuentacontable';

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {

        if (response.data !== '') {
          txtIdCuenta.current.value = response.data.idcuentacontable;
          txtCuentaCont.current.value = maskIt(
            "00-000-00-00-000",
            response.data.codigocuenta
          );
        } else {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Esta cuenta no existe', icono: 'informacion' });
          txtIdCuenta.current.value = '';
          txtCuentaCont.current.value = '';
        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
    })
  };

  const seleccionarCuentas = (id) => {


    let campos = '*';
    let nomtab = 'cuentacontablextiporetencion';
    let nomid = 'idtiporetencion';
    let nomid2 = 'idefiscal';
    let id2 = idefiscal;


    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id=${id}&id2=${id2}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      console.log('llego aqui $', response)

      if (response.status === 200) {
        if (response.data && typeof response.data === "object") {
          console.log("Response data:", response.data);

          response.data.idtiporetencion && seleccionarCuentaRetencion2(response.data.idtiporetencion);

          Array.isArray(response.data) && response.data[0]?.idcuentacontabledepoter &&
            seleccionarCuentaRetencion(response.data[0].idcuentacontabledepoter);
        } else {
          console.error("❌ response.data es inválido:", response.data);
        }

      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const validarInfo = (id) => {
    if (cata === 1) {
      seleccionarCuentaRetencion(id)
    } else {
      seleccionarCuentaRetencion2(id)
    }
  }

  const validarProveedor = (idprov, idcdprov, nomb) => {
    setCatalogoProve(false)
    seleccionarProveedor(idprov)
  }

  const seleccionarRegistroTipReten = (id) => {
    setCatalogoTipoReten(false)
    let campos = '*';
    let nomtab = 'tiporetencion';
    let nomid = 'idtiporetencion';
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (response.data !== '') {
          if (parseInt(response.data.tipo) === 1) {
            setVisibleISLR('visible');
            txtDeducible.current.value = formatMoneda(response.data.deducible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
          }
          console.log(response.data.idtiporetencion)
          seleccionarCuentas(response.data.idtiporetencion)

          switch (parseInt(response.data.unidad)) {
            case 0:
              chkPorcen.current.checked = true;
              break;
            case 1:
              chkMilPorcen.current.checked = true;
              break;
            case 2:
              chkUniTri.current.checked = true;
              break;
            case 3:
              chkMontFij.current.checked = true;
              break;
            case 4:
              chkOtroPor.current.checked = true;
              txtOtroPorcen.current.value = formatMoneda(response.data.otro.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              break;
          }

          cmbTipo.current.value = response.data.tipo;
          txtId.current.value = response.data.idtiporetencion;

          seleccionarProveedor(response.data.idproveedor)

          setValues(
            response.data
          )


        } else {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe un Tipo de Retención con este codigo', icono: 'informacion' });
          txtDescripcion.current.value = '';
        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const validarTipoReten = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value !== '') {

        seleccionarRegistroTipReten(event.target.value);

      } else {
        chkPorcen.current.checked = false;
        chkMilPorcen.current.checked = false;
        chkUniTri.current.checked = false;
        chkMontFij.current.checked = false;
        chkOtroPor.current.checked = false;
        txtDeducible.current.value = '';
        txtOtroPorcen.current.value = '';
        setVisibleISLR('hidden')
        setTercero({
          idagente: '',
          nombre: ''
        })
        setValues({
          idtiporetencion: '',
          descripcion: '',
          unidad: '',
          idcuentacontable: '',
          tipo: '',
          deducible: '',
          otro: '',
          idagente: '',
        })
        txtId.current.value = '';
      }
    }
  };

  const seleccionarCuentaRetencion2 = (id) => {

    setCatalogoCuentaRe(false)
    let campos = '*';
    let nomtab = 'cuentacontable';
    let nomid = 'idcuentacontable';

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {

        if (response.data !== '') {
          txtIdCuenta2.current.value = response.data.idcuentacontable;
          txtCuentaCont2.current.value = maskIt(
            "00-000-00-00-000",
            response.data.codigocuenta
          );
        } else {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Esta cuenta no existe', icono: 'informacion' });
          txtIdCuenta2.current.value = '';
          txtCuentaCont2.current.value = '';
        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
    })
  };

  const validarCuentaContable2 = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value !== '') {
        seleccionarCuentaRetencion2(event.target.value);
      } else {
        txtIdCuenta2.current.value = '';
      }
    }
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion)
        if (props.operacion !== 1) {
          seleccionarRegistroTipReten(props.idReten)
        }
      }}
    >
      <Modal.Header className='header-azulGradiant'>
        <h3>
          {props.operacion === 1 ? 'Agregar Retención' :
            props.operacion === 2 ? 'Editar Retención' :
              props.operacion === 3 ? 'Eliminar Retención' :
                'Consultar Retención'}
        </h3>
        <a type='button'
          onClick={cancelar}>
          salir<i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} >
        </Dimmer>
        <div className='col-12 d-flex flex-wrap p-0 m-0 justify-content-between'>
          {
            props.operacion !== 1 &&
            <div className='col-4 col-lg-2 m-0 p-0'>
              <Input label='Código:'
                name='idcuentabancaria'
                disabled={operacion === 1 || operacion === 2 ? false : true}
                onKeyUp={validarTipoReten}
                onBlur={validarTipoReten}
                ref={txtId}
              />
            </div>
          }
         
           
            <div className="input-group input-group-sm col-7 col-lg-5 mx-0 mb-2 px-0">
              <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Tipo de Retenciones:</span>
              <select
                name="tipo"
                id="tipo"
                onChange={onChange}
                disabled={operacion === 1 ? false : operacion === 2 ? false : true}
                ref={cmbTipo}
                className="form-select"

              >
                <option value="">Seleccione</option>
                <option value="1">Planilla IVA</option>
                <option value="2">Planilla ISLR</option>
                <option value="3">Planilla Impuesto Municipal</option>
                <option value="4">Planilla Timbres Fiscales</option>
                <option value="5">Planilla Responsabilidad Social</option>
                <option value="6">Planilla 1 X 1000</option>
                <option value="2">Otros</option>


                
              </select>

            </div>
         
          {visibleISLR !== 'hidden' &&
            <div className="col-12 m-0 mb-2 p-0">
              <Input label='Deducible:'
                placeholder='0,00'
                name='deducible'
                disabled={operacion === 1 ? false : operacion === 2 ? false : true}
                onKeyUp={handleInputMontoChange}
                onBlur={handleInputMontoChange}
                ref={txtDeducible}
              />
            </div>
          }

          <div className="col-12 p-0 m-0 my-2">
            <Input label='Descripción:'
              disabled={operacion === 1 ? false : operacion === 2 ? false : true}
              value={values.descripcion !== null || values.descripcion !== '' ? values.descripcion : ''}
              name='descripcion'
              onChange={onChange}
              ref={txtDescripcion}
            />
          </div>
          {/* RADIOS */}
          <fieldset className='col-12 border-azul rounded m-0 p-0 p-2 mb-2 d-flex flex-wrap'>
            <legend className='float-none w-auto fw-bold'>
              Unidad de Retención
            </legend>
            <div className='col-12 d-flex p-0 m-0 flex-wrap justify-content-between'>
              <div className='col-6 col-lg-auto p-0 m-0'>
                <Radio label='Porcentaje'
                  name="unidad"
                  id="unidad"
                  onChange={onChange}
                  value={0}
                  disabled={operacion === 1 ? false : operacion === 2 ? false : true}
                  ref={chkPorcen}
                />
              </div>
              <div className='col-6 col-lg-auto m-0 p-0'>
                <Radio label='Mil Porciento'
                  name="unidad"
                  id="unidad1"
                  onChange={onChange}
                  value={1}
                  disabled={operacion === 1 ? false : operacion === 2 ? false : true}
                  ref={chkMilPorcen}
                />
              </div>
              <div className='col-6 col-lg-auto m-0 p-0'>
                <Radio label='Unidad Tributaria'
                  name="unidad"
                  id="unidad2"
                  onChange={onChange}
                  value={2}
                  disabled={operacion === 1 ? false : operacion === 2 ? false : true}
                  ref={chkUniTri}
                />
              </div>
              <div className='col-6 col-lg-auto m-0 p-0'>
                <Radio label='Monto Fijo'
                  name="unidad"
                  id="unidad3"
                  onChange={onChange}
                  value={3}
                  disabled={operacion === 1 ? false : operacion === 2 ? false : true}
                  ref={chkMontFij}
                />
              </div>
            </div>
            <div className='col-12 p-0 m-0 mt-2 d-flex'>
              <Radio label='Otro Porcentaje:'
                name="unidad"
                id="unidad4"
                ref={chkOtroPor}
                onChange={onChange}
                value={4}
                disabled={operacion === 1 ? false : operacion === 2 ? false : true}
              />
              {visibleOtro &&
                <Input
                  placeholder='0,00'
                  name='otro'
                  disabled={operacion === 1 ? false : operacion === 2 ? false : true}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                  ref={txtOtroPorcen}
                />
              }
            </div>
          </fieldset>
          <fieldset className='w-100 col-12 border-azul rounded p-2 m-0 mt-lg-2'>
            <div className="col-12 m-0 p-0 d-flex">
              <div className='col-3 m-0 p-0'>
                <SearchInput label='Código:'
                  name='idcuentabancaria'
                  disabled={operacion === 1 ? false : operacion === 2 ? false : true}
                  defaultValue={tercero.idagente !== null || tercero.idagente !== '' ? tercero.idagente : ''}
                  onKeyUp={validarBene}
                  onBlur={validarBene}
                  ref={txtIdProve}
                  onClickButton={() => { setCatalogoProve(true) }}
                  disabledButton={operacion === 1 || operacion === 2 ? false : true}
                />
              </div>
              <Input
                name='idcuentabancaria'
                disabled
                defaultValue={tercero.nombre !== null || tercero.nombre !== '' ? tercero.nombre.trim() : ''}
              />
            </div>
          </fieldset>
          <fieldset className='col-12 col-lg-6 p-2 m-0 mt-2 border-azul rounded'>
            <legend className="float-none w-auto fw-bold">
              Cuenta contable retencion por pagar
            </legend>
            <div className="col-12 p-0 m-0 d-flex">
              <div className='col-6 m-0 p-0'>
                <SearchInput label='Código:'
                  name='idcuentabancaria'
                  disabled={operacion === 1 ? false : operacion === 2 ? false : true}
                  onKeyUp={validarCuentaContable}
                  onBlur={validarCuentaContable}
                  ref={txtIdCuenta}
                  disabledButton={operacion === 1 || operacion === 2 ? false : true}
                  onClickButton={mostrarCuenta(1)}
                />
              </div>
              <Input
                name='idcuentabancaria'
                disabled
                ref={txtCuentaCont}
              />
            </div>
          </fieldset>
          <div className='col-12 col-lg-6 pl-lg-2 p-0 m-0 mt-2'>
            <fieldset className='col-12 m-0 p-2 border-azul rounded'>
              <legend className="float-none w-auto fw-bold">
                Cuenta contable deposito de tercero
              </legend>
              <div className="col-12 p-0 m-0 d-flex">
                <div className='col-6 m-0 p-0'>
                  <SearchInput label='Código:'
                    name='idcuentabancaria'
                    disabled={operacion === 1 ? false : operacion === 2 ? false : true}
                    onKeyUp={validarCuentaContable2}
                    onBlur={validarCuentaContable2}
                    ref={txtIdCuenta2}
                    disabledButton={operacion === 1 || operacion === 2 ? false : true}
                    onClickButton={mostrarCuenta(2)}
                  />
                </div>
                <Input
                  name='idcuentabancaria'
                  ref={txtCuentaCont2}
                  disabled
                />
              </div>
            </fieldset>
          </div>
          <CatalogoTipoReten
            show={catalogoTipoReten}
            onHideCancelar={() => { setCatalogoTipoReten(false) }}
            onHideAceptaCatalogo={seleccionarRegistroTipReten}
          />
          <CatalogoProveedor
            show={catalogoProve}
            onHideCancelaCatProv={() => { setCatalogoProve(false) }}
            onHideAceptaCatProv={validarProveedor}
          />
          <CatalogoCuentaContable
            show={catalogoCuentaRe}
            onHideCancelaCatProv={() => { setCatalogoCuentaRe(false) }}
            onHideAceptaCatProv={validarInfo}
          />
        </div>
      </Modal.Body >
      <Modal.Footer>
        <SuccessButton
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
    </Modal >
  );
}

